import { IWelcomeMessageProps } from '@/features/shared/portal/WelcomeMessage/WelcomeMessage.interfaces';

import { isVariantOf, ComponentsVariants } from '@/components.variants';

export const isWelcomeMessage = isVariantOf(ComponentsVariants.WELCOME_MESSAGE, true);

export default ({ beforeMessage, afterMessage }: IWelcomeMessageProps) => ({
  variant: ComponentsVariants.WELCOME_MESSAGE,
  beforeMessage,
  afterMessage,
});
